export const painPoints = [
  {
    emoji: '😱',
    title: 'Confrontás en caliente y perdés toda ventaja',
    desc: 'Gritás, llorás o amenazás sin estrategia. El otro se cierra, borra evidencia y vos quedás como el/la "histérico/a" de la situación.',
  },
  {
    emoji: '🌙',
    title: 'No dormís y el scrolleo te destruye',
    desc: 'Revisás su perfil, sus fotos, sus contactos a las 3 AM. Cada imagen es un cuchillo nuevo. Estás buscando respuestas donde solo hay más dolor.',
  },
  {
    emoji: '🎭',
    title: 'Te hacen dudar de tu propia cordura',
    desc: 'Te dicen que imaginás, que estás paranoico/a, que exagerás. El Gaslighting te confunde hasta que ya no sabés qué es real y qué no.',
  },
  {
    emoji: '🔍',
    title: 'No sabés qué es real y qué es mentira',
    desc: 'Obtenés respuestas vagas, contradictorias y llenas de medias verdades que no cierran ninguna herida sino que abren nuevas.',
  },
  {
    emoji: '💔',
    title: 'No sabés si perdonar, intentar o cortar',
    desc: 'Te falta un criterio concreto para evaluar si la relación tiene futuro o si lo más inteligente es ejecutar una salida digna y planificada.',
  },
  {
    emoji: '🔁',
    title: 'Tomás decisiones y después te arrepentís',
    desc: 'Cada movimiento en caliente genera consecuencias que después son muy difíciles o imposibles de revertir.',
  },
];
